
import store from '@/state/store';
import { getToken, setToken } from '@/services/http.service';

export default (https) => {
  // ✅ Setup interceptor before returning the service
  https.interceptors.response.use(
    response => response,
    async error => {
      if (error.response && error.response.status === 401) {
        if (!error.config._retry) {
          error.config._retry = true;
          try {
            const token = getToken();
            if (token) {
              await https.post(`/logout`, { token });
            }
          } catch (logoutErr) {
            console.error('Auto logout failed:', logoutErr);
          } finally {
            localStorage.removeItem('token');
            sessionStorage.removeItem('token');
            store.dispatch('auth/setUser', {});
            window.location.href = '/login'; // or router.push('/login');
          }
        }
      }
      return Promise.reject(error);
    }
  );

  return {
    async loginUser(payload) {
      try {
        const response = await https.post(`/login`, payload);
        const token = response.data.data.access_token;
        console.log(token, 'token');
        setToken(token);
        this.setLocalStorageToken(token);
        return response.data;
      } catch (error) {
        console.error('Login failed:', error);
        throw error;
      }
    },

    async registerUser(payload) {
      try {
        const response = await https.post(`/buyer-register`, payload);
        const token = response.data.data.access_token;
        console.log(token, 'token');
        this.setLocalStorageToken(token);
        return response.data;
      } catch (error) {
        console.error('Registration failed:', error);
        throw error;
      }
    },

    setLocalStorageToken(token) {
      localStorage.setItem('token', token);
    },
   async verifyEmail(payload) {
      try {
        const response = await https.post(`/verify-email`, payload);
        return response.data;
      } catch (error) {
        console.error('Verify Emails failed:', error);
        throw error;
      }
    },
    async sendResetCode(payload) {
      return await https.post(`/send-password-reset-code`, payload);
    },

    async validateResetCode(payload) {
      return await https.post(`/verify-code`, payload);
    },
 async resendCode(payload) {
      return await https.post(`/verify-code`, payload);
    },
    async resetPassword(payload) {
      return await https.post(`/password-reset`, payload);
    },

    async changePasswordUser(payload) {
      return await https.post(`/update-password`, payload);
    },

    async changeProfileUser(payload) {
      return await https.post(`/update-profile`, payload);
    },

    reject() {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      if (token) {
        this.logOut();
      }
    },

    async logOut() {
      const token = getToken();
      console.log(token, 'token');
      try {
        await https.post(`/logout`, { token });
      } catch (error) {
        console.error('Logout failed:', error);
      } finally {
        if (token) {
          localStorage.removeItem('token');
          sessionStorage.removeItem('token');
          store.dispatch('auth/setUser', {});
          window.location.href = '/login'; // or use router.push
        }
      }
    }
  };
};
